import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";
import { SCENES } from "@/lib/watchImages";

const IMG = SCENES.landingHero;

const rituals = [
  {
    when: "06:42",
    label: "Locker Room",
    text: "Wound by hand. The mechanical heart of the day begins.",
  },
  {
    when: "07:15",
    label: "Clubhouse Terrace",
    text: "Coffee, the scorecard, the long look at the first hole.",
  },
  {
    when: "07:48",
    label: "First Tee",
    text: "Stroke counter set to zero. The course is acknowledged. The round begins.",
  },
];

export default function PrivateClub() {
  return (
    <section
      id="club"
      data-testid={TID.sectionClub}
      className="relative overflow-hidden bg-[#1F382A] border-t border-[rgba(197,160,89,0.35)]"
    >
      <div aria-hidden="true" className="absolute inset-0 opacity-75">
        <img
          src={IMG}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#14201a] via-[#14201a]/40 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#14201a]/70 via-transparent to-[#14201a]/30" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-28 sm:py-40">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3">
            <span className="gold-rule" />
            <span className="overline">The Wearing</span>
          </div>
          <h2 className="font-serif-display text-[#F5F2EB] font-light text-balance text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mt-6">
            How a CLEMENT is{" "}
            <span className="italic text-[#C5A059]">worn</span>.
          </h2>
          <p className="text-[#A8A9AD] text-base sm:text-lg leading-relaxed mt-8 max-w-xl">
            From the morning the watch is wound to the handshake on
            eighteen. CLEMENT is the small, deliberate piece of the day
            that does not change — and never asks to be charged.
          </p>
        </motion.div>

        <div className="mt-16 flex flex-wrap justify-center">
          {rituals.map((r, i) => (
            <motion.div
              key={r.when}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: "easeOut" }}
              className="bg-[#0C0F0A] p-8 sm:p-10 w-full md:w-1/3 border border-[rgba(197,160,89,0.15)] -mt-px -ml-px box-border"
            >
              <div className="font-serif-display text-[#C5A059] text-3xl sm:text-4xl">
                {r.when}
              </div>
              <div className="overline mt-3">{r.label}</div>
              <p className="text-[#A8A9AD] leading-relaxed mt-5 text-sm sm:text-base">
                {r.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
